<div>
    @if(isNextSeason) {
    <p class="alert alert-info-centre" role="alert">
        <i class="fa-solid fa-circle-info"></i> You are applying for the {{applicationSeason}} season
    </p>
    }

    <h4>Hi {{name}}</h4>
    <p class="centre">Welcome to your homepage!</p>

    @if(userState) {
    <p class="centre">
        <span innerHTML="{{userState}}"></span>
    </p>
    @if(userStateExtra) {
    <p class="left">
        <span innerHTML="{{userStateExtra}}"></span>
    </p>
    }
    }
</div>